// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.balance-grid {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 1rem;
}
.balance-grid.second-col-only > :first-child {
  visibility: hidden;
}

.balance-row {
  display: grid;
  grid-template-columns: 1fr auto 1fr;
  align-items: center;
  gap: 1rem;
}
.balance-row.amount > :first-child {
  text-align: right;
}
.balance-row.total > :first-child {
  grid-column: 1/span 2;
}`, "",{"version":3,"sources":["webpack://./src/app/components/v-cash-register-balance/v-cash-register-balance.component.sass"],"names":[],"mappings":"AAAA;EACE,aAAA;EACA,8BAAA;EACA,SAAA;AACF;AAEI;EACE,kBAAA;AAAN;;AAEA;EACE,aAAA;EACA,mCAAA;EACA,mBAAA;EACA,SAAA;AACF;AAEI;EACE,iBAAA;AAAN;AAGI;EACE,qBAAA;AADN","sourcesContent":[".balance-grid\n  display: grid\n  grid-template-columns: 1fr 1fr\n  gap: 1rem\n\n  &.second-col-only\n    > :first-child\n      visibility: hidden\n\n.balance-row\n  display: grid\n  grid-template-columns: 1fr auto 1fr\n  align-items: center\n  gap: 1rem\n\n  &.amount\n    > :first-child\n      text-align: right\n\n  &.total\n    > :first-child\n      grid-column: 1 / span 2\n\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
